import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { WineAppProvider } from '../context/WineAppContext';
import WineApp from '../WineApp';
import AboutPage from '../components/pages/AboutPage';
import AdminPage from '../components/pages/AdminPage';
import RestaurantMenuPage from '../components/pages/RestaurantMenuPage';

const AppRouter = () => {
    return (
        <Router>
            <WineAppProvider>
                <Routes>
                    {/* Root redirect to welcome */}
                    <Route path="/" element={<Navigate to="/welcome" replace />} />
                    
                    {/* Step routes */}
                    <Route path="/welcome" element={<WineApp step="welcome" />} />
                    <Route path="/cooking" element={<WineApp step="cooking" />} />
                    <Route path="/restaurant" element={<WineApp step="restaurant" />} />
                    <Route path="/wine-preferences" element={<WineApp step="wine-preferences" />} />
                    <Route path="/food-preferences" element={<WineApp step="food-preferences" />} />
                    <Route path="/price-range" element={<WineApp step="price-range" />} />
                    <Route path="/recommendations" element={<WineApp step="recommendations" />} />
                    <Route path="/menu" element={<RestaurantMenuPage />} />
                    
                    {/* About page */}
                    <Route path="/about" element={<AboutPage />} />
                    
                    {/* Admin page */}
                    <Route path="/admin" element={<AdminPage />} />
                    
                    {/* Catch all route */}
                    <Route path="*" element={<Navigate to="/welcome" replace />} />
                </Routes>
            </WineAppProvider>
            <Analytics />
        </Router>
    );
};

export default AppRouter;
